import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'
import type { Database } from '@/integrations/supabase/types'

// Custom hook to check if a team has a premium subscription
export function useTeamSubscription(teamId: string | undefined | null) {
	return useQuery({
		queryKey: ['team-subscription', teamId],
		queryFn: async () => {
			if (!teamId) {
				return { isPremium: false }
			}

			// Fetch the team's subscription status
			const { data, error } = await supabase
				.from('teams')
				.select('subscription_status')
				.eq('id', teamId)
				.single()

			if (error) {
				console.error('Error fetching team subscription:', error)
				return { isPremium: false }
			}

			// Check if the subscription status indicates a premium account
			// Active or trialing subscriptions are considered premium
			const isPremium =
				data?.subscription_status === 'active' ||
				data?.subscription_status === 'trialing'

			return { isPremium }
		},
		enabled: !!teamId,
	})
}
